import React, { useState, useEffect, useContext } from 'react';
import { Table, Form, Pagination } from 'react-bootstrap';
import {

    get_test_name_group_API_TestReports,
   get_user_colleges_API,
    get_Departments_TestReports,
    get_Test_Names_TestReports,
    get_Colleges_TestReports
} from '../../api/endpoints';

import { Link } from 'react-router-dom';
import '../../styles/global.css';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { SearchContext } from '../../allsearch/searchcontext';
import UploadTestReport from './uploadtestReport';
import DatePicker from 'react-datepicker';

import CustomPagination from '../../api/custompagination';

const TestReports = ({ institute, userRole,username }) => {
    const [testCandidates, setTestCandidates] = useState([]);
    const [testCandidatesUnique, setTestCandidatesUnique] = useState([]);
    const [isUnique, setIsUnique] = useState(true);
    const [searchable, setSearchable] = useState('');
    const { searchQuery } = useContext(SearchContext);
    // const { collegeId } = useParams();
    const [testNameFilter, setTestNameFilter] = useState("");
    const [departmentFilter, setDepartmentFilter] = useState("");
    const [yearFilter, setYearFilter] = useState("");
    const [topicFilter, setTopicFilter] = useState("");
    const [collegeNameFilter, setCollegeNameFilter] = useState("");
    const [departments, setDepartments] = useState([]);
    const [colleges, setColleges] = useState([]);
    const [testNames, setTestNames] = useState([]);
    // console.log("collegeId",institute)  ;
    // console.log("user_role",userRole)
    const [fromDateFilter, setFromDateFilter] = useState("");
    const [toDateFilter, setToDateFilter] = useState("");


    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages1, setTotalPages1] = useState(1);
    const [pageSize] = useState(10); // Items per page


    useEffect(() => {
        getTestCandidates();  // ✅ Fetch data when filters change
        getTestCandidatesFilter();
    }, [collegeNameFilter, departmentFilter, yearFilter, testNameFilter, fromDateFilter, toDateFilter]);



    // Fetch colleges when component mounts
    useEffect(() => {
        getTestCandidates(currentPage);
    }, [currentPage]);


    const handlePageChange1 = (page) => {
        setCurrentPage(page);
    };
const getTestCandidates = (page) => {
    console.log("➡️ STEP 1: getTestCandidates called");
    console.log("User Role:", userRole, "Username:", username);

    let collegeIdToSend = userRole === "Placement Officer" ? institute : null;
    let departmentIdToSend = departmentFilter || null;
    let yearToSend = yearFilter?.trim() || null;
    let testNameToSend = testNameFilter?.trim() || null;

    // Add 1 day to fromDateFilter
    let adjustedFromDate = fromDateFilter ? new Date(fromDateFilter) : null;
    if (adjustedFromDate) adjustedFromDate.setDate(adjustedFromDate.getDate() + 1);
    let fromDateToSend = adjustedFromDate ? adjustedFromDate.toISOString().split("T")[0] : null;
    let toDateToSend = toDateFilter ? toDateFilter.toISOString().split("T")[0] : null;

    // ✅ For Super Admin, get ID from selected college
    if (userRole === "Super admin" && collegeNameFilter) {
        let selectedCollege = colleges.find(college => college.college_id__college === collegeNameFilter);
        if (selectedCollege) {
            collegeIdToSend = selectedCollege.college_id__id || selectedCollege.college_id;
        }
    }

    console.log("➡️ STEP 2: Fetching test data from API");

    get_test_name_group_API_TestReports(
        collegeIdToSend || null,
        departmentIdToSend || null,
        yearToSend || null,
        testNameToSend || null,
        fromDateToSend || null,
        toDateToSend || null,
        page
    )
    .then((data) => {
        console.log("➡️ STEP 3: API Response:", data);

        if (userRole === "Training admin" || userRole === "Placement admin") {
            console.log("➡️ STEP 4: Filtering data for allowed colleges");

            // Get allowed college IDs for this user
           get_user_colleges_API(username)
  .then((userData) => {
      const allowedCollegeIds = userData.college_ids || [];
      console.log("➡️ STEP 5: Allowed college IDs:", allowedCollegeIds);

      // Convert types to match
      const filteredResults = data.results.filter(item =>
          allowedCollegeIds.map(Number).includes(Number(item.college_id))
      );

      setTestCandidates(filteredResults);
      setTotalPages1(Math.ceil(filteredResults.length / pageSize));
      console.log("➡️ STEP 6: ✅ Filtered Test Candidates count:", filteredResults.length);
  })
  .catch((error) => {
      console.error("❌ Error fetching allowed colleges:", error);
  });

        } else {
            // Other roles use full data
            setTestCandidates(data.results);
            setTotalPages1(Math.ceil(data.count / pageSize));
            console.log("➡️ STEP 4: ✅ Test Candidates count:", data.results.length);
        }
    })
    .catch((error) => {
        console.error("❌ Error fetching test candidates:", error);
    });
};


const getTestCandidatesFilter = () => {
    let collegeIdToSend = userRole === "Placement Officer" ? institute : null;
    let departmentIdToSend = null;
    let yearToSend = yearFilter?.trim() || null;
    let testNameToSend = testNameFilter?.trim() || null;

    // ✅ Super Admin college filter
    if (userRole === "Super admin" && collegeNameFilter) {
        let selectedCollege = colleges.find(college => college.college_id__college === collegeNameFilter);
        if (selectedCollege) {
            collegeIdToSend = selectedCollege.college_id__id || selectedCollege.college_id;
        }
    }

    if (departmentFilter) {
        departmentIdToSend = departmentFilter;
    }

    get_Colleges_TestReports(
        departmentIdToSend || null,
        yearToSend || null,
        testNameToSend || null
    )
    .then((data) => {
        setColleges(data);
    })
    .catch((error) =>
        console.error("Error fetching colleges:", error)
    );

    get_Departments_TestReports(
        collegeIdToSend || null,
        yearToSend || null,
        testNameToSend || null
    )
    .then((data) => {
        setDepartments(data);
    })
    .catch((error) =>
        console.error("Error fetching departments:", error)
    );

    get_Test_Names_TestReports(
        collegeIdToSend || null,
        yearToSend || null,
        departmentIdToSend || null
    )
    .then((data) => {
        setTestNames(data);
    })
    .catch((error) =>
        console.error("Error fetching test names:", error)
    );
};


    useEffect(() => {
        setCurrentPage(1); // Reset to first page on search
    }, [searchable, searchQuery, testNameFilter, departmentFilter, yearFilter, collegeNameFilter]);

    const uniqueCollegeNames = [...new Set(testCandidatesUnique.map((item) => item.college_name))];

    const uniqueTestNames = [...new Set(testCandidatesUnique.map((item) => item.test_name))];
    const uniqueDepartments = departments.map((dept) => dept.department);
    const uniqueYears = [...new Set(
        testCandidatesUnique.flatMap((item) => (item.year ? item.year.split(", ") : []))
    )];
    // ✅ Ensure all options always appear in dropdowns



    const [itemsPerPage, setItemsPerPage] = useState(10);

    // Calculate pagination values


    // Calculate pagination values
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = testCandidates.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(testCandidates.length / itemsPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);



    const refreshTestCandidates = () => {
        getTestCandidates(); // Fetch updated data
    };


    const filteredData = testCandidates.filter(item => {
        const fromDate = fromDateFilter ? new Date(fromDateFilter.setHours(0, 0, 0, 0)) : null;
        const toDate = toDateFilter ? new Date(toDateFilter.setHours(23, 59, 59, 999)) : null;
        const testDateEnd = new Date(item.dtm_end);

        const isInDateRange = (
            (!fromDate || testDateEnd >= fromDate) &&
            (!toDate || testDateEnd <= toDate)
        );

        return (
            isInDateRange &&
            (!searchQuery ||
                (item.test_name && item.test_name.toLowerCase().includes(searchQuery.toLowerCase())) ||
                (item.college_name && item.college_name.toLowerCase().includes(searchQuery.toLowerCase())) ||
                (item.department_name && item.department_name.toLowerCase().includes(searchQuery.toLowerCase())) ||
                (item.year && item.year.toLowerCase().includes(searchQuery.toLowerCase()))
            )
        );
    });

    const exportToExcel = async () => {
        if (filteredData.length === 0) {
            alert("No data available to export!");
            return;
        }

        const testName = testNameFilter || "Test";
        const collegeName = collegeNameFilter || "College";

        // Add 1 day to fromDateFilter
        let adjustedFromDate = fromDateFilter ? new Date(fromDateFilter) : null;
        if (adjustedFromDate) {
            adjustedFromDate.setDate(adjustedFromDate.getDate() + 1);
        }
        let fromDateToSend = adjustedFromDate
            ? adjustedFromDate.toISOString().split("T")[0]
            : null;

        const startDate = fromDateToSend || "StartDate";
        const fileName = `${testName}_${collegeName}_${startDate}.xlsx`;
        const sheetName = `${testName} Report`;

        // Utility to format date
        const formatDate = (dateStr, format = "dd-mm-yyyy") => {
            const date = new Date(dateStr);
            const dd = String(date.getDate()).padStart(2, '0');
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const yyyy = date.getFullYear();
            return format === "dd-mm-yyyy" ? `${dd}-${mm}-${yyyy}` : dateStr;
        };

        // Transform data
        const transformedData = filteredData.map(item => ({
            "College": item.college_name,
            "Department": item.department_name,
            "Year": item.year,
            "Test Name": item.test_name,
            "Start Date": formatDate(item.dtm_start),
            "End Date": formatDate(item.dtm_end),
            "Total Assigned": item.student_count,
            "Total Attended": item.active_student_count
        }));

        // Create workbook and worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(sheetName);

        // Add header row
        const headers = Object.keys(transformedData[0]);
        worksheet.addRow(headers);

        // Add data rows
        transformedData.forEach(row => {
            worksheet.addRow(Object.values(row));
        });

        // Auto-adjust column widths
        worksheet.columns.forEach(column => {
            let maxLength = 12;
            column.eachCell({ includeEmpty: true }, cell => {
                const valLength = (cell.value || "").toString().length;
                if (valLength > maxLength) maxLength = valLength;
            });
            column.width = maxLength + 2;
        });

        // Export file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        saveAs(blob, fileName);
    };


    // Helper function to format date
    const formatDate = (date, format) => {
        const options = { day: "2-digit", month: "2-digit", year: "numeric" };
        if (!date) return "";
        const parsedDate = new Date(date);
        return parsedDate.toLocaleDateString("en-GB", options).replace(/\//g, "-");
    };




    return (
        <div className='table-testschedule'>


            <div className="product-table-container">
                <h6>Test Report</h6>
                {userRole === "Super admin" && (
                    <>
                        <UploadTestReport onUploadSuccess={refreshTestCandidates} />
                        <p></p>
                    </>
                )}

                <div className='upload-repo'
                    style={{ display: 'flex', borderRadius: '8px', border: '1px solid', width: 'fit-content' }}>

                    <div className="date-filters">
                        <div className="date-picker-container">
                            <div style={{ marginRight: "10px" }}></div>
                            <label style={{ marginRight: "10px" }}>From Date:</label>
                            <DatePicker
                                name="from_date"
                                selected={fromDateFilter}
                                onChange={(date) => {
                                    if (date) {
                                        // Only set the date if it's not null
                                        const startOfDay = new Date(date.setHours(0, 0, 0, 0)); // Set to start of day
                                        setFromDateFilter(startOfDay);
                                    } else {
                                        // Handle the case when the date is cleared
                                        setFromDateFilter(null);
                                    }
                                }}
                                dateFormat="dd-MM-yyyy"
                                className="input-date-custom-rep"
                            />



                            <label style={{ marginRight: "10px" }}>To Date:</label>

                            <DatePicker
                                name='to_date'
                                selected={toDateFilter}
                                onChange={(date) => {
                                    if (date) {
                                        const endOfDay = new Date(date.setHours(23, 59, 59, 999)); // Set to end of day
                                        setToDateFilter(endOfDay);
                                    } else {
                                        // Handle the case when the date is cleared
                                        setToDateFilter(null);
                                    }
                                }}
                                dateFormat="dd-MM-yyyy"
                                className='input-date-custom-rep'
                            />

                            <button onClick={exportToExcel} className="button-ques-save-down-re" >Download</button>
                        </div>
                    </div>
                </div>

                <div className='table-responsive-schedule'>
                    <table className="product-table" >

                        <thead className="table-thead" style={{ textAlign: "center" }}>
                            <tr>
                                {userRole !== "Placement Officer" && (
                                    <th style={{ textAlign: "center" }}>CollegeName
                                    </th>)}
                                <th style={{ width: "200px", textAlign: "center" }}>
                                    Test Name

                                </th>
                                <th style={{ textAlign: "center" }}>
                                    Department Name

                                </th>
                                <th style={{ textAlign: "center" }}>
                                    Year

                                </th>


                                <th style={{ textAlign: "center" }}>Total Students</th>
                            </tr>
                            <tr>
                               {(userRole === "Super admin"|| userRole === "Training admin" ) && (
    <th style={{ textAlign: "center" }}>
        <select
            className="dropdown-custom college-name-dropdown"
            value={collegeNameFilter}
            onChange={(e) => setCollegeNameFilter(e.target.value)}
        >
            <option value="">All</option>
            {colleges.map((name) => (
                <option key={name.id} value={name.college_id__college}>
                    {name.college_id__college}
                </option>
            ))}
        </select>
    </th>
)}

                                <th style={{ textAlign: "center" }}>

                                    <select className="dropdown-custom college-name-dropdown" value={testNameFilter} onChange={(e) => setTestNameFilter(e.target.value)}>
                                        <option value="">All</option>

                                        {testNames.map((test) => (
                                            <option key={test.test_name} value={test.test_name}>
                                                {test.test_name}
                                            </option>
                                        ))}
                                    </select>
                                </th>
                                <th style={{ textAlign: "center" }}>
                                    <select
                                        className="dropdown-custom"
                                        value={departmentFilter}
                                        onChange={(e) => setDepartmentFilter(e.target.value)}
                                    >
                                        <option value="">All</option>
                                        {departments.map((dept) => (
                                            <option key={dept.id} value={dept.department_id}>
                                                {dept.department_id__department}
                                            </option>
                                        ))}
                                    </select>
                                </th>
                                <th style={{ textAlign: "center" }}>
                                    <select
                                        className="dropdown-custom"
                                        value={yearFilter}
                                        onChange={(e) => setYearFilter(e.target.value)}
                                    >
                                        <option value="">All</option>
                                        {uniqueYears.map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </select>
                                </th>

                                <th style={{ textAlign: "center" }}></th>

                            </tr>

                        </thead>

                        <tbody className="table-tbody" style={{ fontSize: '14px' }} >
                            {testCandidates
                                .map((item) => (
                                    <tr key={item.id} className="table-row">
                                        {userRole !== "Placement Officer" && (<td style={{ textAlign: "center" }}>{item.college_name}</td>)}
                                        <td style={{ textAlign: "center" }}>{item.test_name}</td>

                                        <td style={{ textAlign: "center" }}>{item.department_name}</td>
                                        <td style={{ textAlign: "center" }}>
                                            {item.year?.replace(/^,/, "")}
                                        </td>



                                        <td style={{ textAlign: 'center' }}>
                                            <Link
                                                to={userRole === "Placement Officer" ? `/test-result/placement/?test_name=${encodeURIComponent(item.test_name)}&college_id=${encodeURIComponent(item.college_name)}&department_id=${encodeURIComponent(item.department_name || "All")}&year=${encodeURIComponent(item.year)}` :
                                                    `/test-result/top/?test_name=${encodeURIComponent(item.test_name)}&college_id=${encodeURIComponent(item.college_name)}&department_id=${encodeURIComponent(item.department_name)}&year=${encodeURIComponent(item.year)}`}
                                                style={{ color: "white" }}
                                            >      {item.active_student_count}
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
                <p></p>




                <div className='dis-page' style={{ marginTop: '10%' }}>
                    {/* Custom Pagination */}
                    <CustomPagination
                        totalPages={totalPages1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange1}
                        maxVisiblePages={3} // Limit to 3 visible pages
                    />
                </div>

            </div>
        </div>
    );
};

export default TestReports;

